import { domAnimation, m } from 'framer-motion';
import { useState } from 'react';

import ChevronIcon from '~/assets/icons/Chevron';
import FramerMotion from '~/components/FramerMotion';

import ProductDetails from './ProductDetails';

const ProductDetailsToggle = ({
  isOpen,
  onClick
}: {
  isOpen: boolean;
  onClick: () => void;
}) => {
  function onButtonClick() {
    onClick();

    if (isOpen) {
      window.scrollTo({
        behavior: 'smooth',
        top: 0
      });
    }
  }

  return (
    <button
      data-cy="product-details-toggle"
      onClick={onButtonClick}
      className="flex items-center gap-2"
    >
      <p className="font-bold ">{isOpen ? 'Read less' : 'Read more'}</p>
      <div className={isOpen ? 'rotate-180' : ''}>
        <ChevronIcon height="20" width="12" stroke="black" />
      </div>
    </button>
  );
};

type Props = {
  showEditorialPolicy?: boolean;
};

const ProductDetailsTruncated = ({ showEditorialPolicy }: Props) => {
  const [showProductDetails, setShowProductDetails] = useState(false);

  const toggleProductDetails = () => setShowProductDetails(!showProductDetails);

  return (
    <>
      <div className="mb-6">
        <ProductDetailsToggle
          isOpen={showProductDetails}
          onClick={toggleProductDetails}
        />
      </div>
      {showProductDetails ? (
        <FramerMotion feature={domAnimation}>
          <m.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
            className="mb-6"
          >
            <ProductDetails showEditorialPolicy={showEditorialPolicy} />
            <ProductDetailsToggle
              isOpen={showProductDetails}
              onClick={toggleProductDetails}
            />
          </m.div>
        </FramerMotion>
      ) : null}
    </>
  );
};

export default ProductDetailsTruncated;
